import { render, staticRenderFns } from "./Utilizatori_program.vue?vue&type=template&id=833c89d0&scoped=true&"
import script from "./Utilizatori_program.vue?vue&type=script&lang=js&"
export * from "./Utilizatori_program.vue?vue&type=script&lang=js&"
import style0 from "./Utilizatori_program.vue?vue&type=style&index=0&id=833c89d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833c89d0",
  null
  
)

export default component.exports